export default __webpack_public_path__ + "static/media/error.c2de3040.svg";